import {Component, OnInit} from '@angular/core';
import {Constants} from "../../constants";
import {IMPShareLinkModule} from "../marketing-page.models";
import {BaseComponent} from "../../base.component";
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {IShareLinkOptions} from "../../social/social-models";

@Component({
    templateUrl: './share-link.component.html',
    styleUrls: ['./share-link.component.scss'],
    standalone: false
})
export class ShareLinkComponent extends BaseComponent implements OnInit {

    pageUrl: string;
    componentData: IMPShareLinkModule;
    useLocaleOverride: boolean;
    shareOptions: IShareLinkOptions;

    constructor(private loggerService: LoggerService, private userService: UserService) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.shareOptions = {shareType: Constants.SHARE_TYPE_MARKETING_PAGE, shareId: this.pageUrl, shareFrom: Constants.MARKETING_PAGE_STATE};
    }
}
